import { Box, type BoxProps, Slider, type SliderProps, type SxProps, Typography } from "@mui/material";
import type { Theme } from "@mui/material/styles";
import type React from "react";

export interface IRangeSliderProps extends SliderProps {
  leftLabel?: React.ReactNode;
  rightLabel?: React.ReactNode;
  labelColor?: string;
  ContainerProps?: BoxProps;
  leftLabelStyle?: SxProps<Theme>;
  rightLabelStyle?: SxProps<Theme>;
  SliderContainerProps?: SxProps<Theme>;
}

export const RangeSlider = ({
  id,
  leftLabel,
  rightLabel,
  labelColor,
  ContainerProps,
  SliderContainerProps,
  rightLabelStyle,
  leftLabelStyle = { minWidth: "110px" },
  ...rest
}: IRangeSliderProps) => {
  return (
    <Box display="flex" alignItems="center" {...ContainerProps}>
      {leftLabel && (
        <Typography variant="body1SemiBold" color={labelColor} sx={leftLabelStyle}>
          {leftLabel}
        </Typography>
      )}
      <Box sx={{ display: "flex", alignItems: "center", width: "50%", px: 2, ...SliderContainerProps }}>
        <Slider id={id} data-testid={`${id}-test`} {...rest} />
      </Box>
      {rightLabel && (
        <Typography variant="body1SemiBold" color={labelColor} sx={rightLabelStyle}>
          {rightLabel}
        </Typography>
      )}
    </Box>
  );
};
